module.exports = __webpack_public_path__ + "img/default_avatar.1132d0b2.jpg";